import { useEffect, useRef } from "react";

// Conexión WebSocket a /api/ws/agenda con reconexión automática.
// onMessage recibe el objeto JSON difundido por el backend (agenda_update | alerta).
// PROMPT 127: los avisos traen datos de clientes, así que el servidor pide la sesión: apenas
// se abre la conexión se manda {"tipo": "auth", "token": <el de la sesión>}. Sin sesión
// válida el servidor cierra con 4401 y se vuelve a probar recién al minuto (por si se
// vuelve a iniciar sesión), en vez de cada 4 segundos.
const SIN_SESION = 4401;
export function useAgendaSocket(onMessage) {
  const cbRef = useRef(onMessage);
  cbRef.current = onMessage;

  useEffect(() => {
    const base = process.env.REACT_APP_BACKEND_URL || "";
    const wsUrl = base.replace(/^http/i, "ws") + "/api/ws/agenda";
    let ws;
    let closed = false;
    let retry;
    let pulso;

    // PROMPT 152: cada minuto, con la plataforma a la vista y con foco, le avisa al servidor que esta persona la
    // esta usando: mientras tanto el aviso del telefono no suena (llega recien a los 2 minutos sin usarla).
    const latido = () => {
      try {
        if (ws && ws.readyState === WebSocket.OPEN && document.visibilityState === "visible" && document.hasFocus()) {
          ws.send(JSON.stringify({ tipo: "activo" }));
        }
      } catch (err) {
        /* ignore */
      }
    };

    const connect = () => {
      if (!localStorage.getItem("tny_token")) {
        retry = setTimeout(connect, 60000);
        return;
      }
      try {
        ws = new WebSocket(wsUrl);
      } catch (e) {
        retry = setTimeout(connect, 4000);
        return;
      }
      ws.onopen = () => {
        try {
          ws.send(JSON.stringify({ tipo: "auth", token: localStorage.getItem("tny_token") || "" }));
        } catch (err) {
          /* ignore */
        }
        latido();
        clearInterval(pulso);
        pulso = setInterval(latido, 60000);
      };
      ws.onmessage = (e) => {
        try {
          cbRef.current?.(JSON.parse(e.data));
        } catch (err) {
          /* ignore */
        }
      };
      ws.onclose = (ev) => {
        clearInterval(pulso);
        if (!closed) retry = setTimeout(connect, ev?.code === SIN_SESION ? 60000 : 4000);
      };
      ws.onerror = () => {
        try {
          ws.close();
        } catch (err) {
          /* ignore */
        }
      };
    };

    window.addEventListener("focus", latido);
    document.addEventListener("visibilitychange", latido);
    connect();
    return () => {
      closed = true;
      clearTimeout(retry);
      clearInterval(pulso);
      window.removeEventListener("focus", latido);
      document.removeEventListener("visibilitychange", latido);
      try {
        if (ws) {
          if (ws.readyState === WebSocket.CONNECTING) {
            // Evita el warning "closed before established" (StrictMode doble montaje)
            ws.onopen = () => ws.close();
          } else {
            ws.close();
          }
        }
      } catch (e) {
        /* ignore */
      }
    };
  }, []);
}
